import React from "react";
import { useTranslation } from "react-i18next";
import { useBackNavigation } from "../../components/navigation/BackButton";
import UserProfileView from "./profile/UserProfileView";

export default function ParentProfile() {
  const { t } = useTranslation();
  const goBack = useBackNavigation("/portal");

  return (
    <UserProfileView t={t} onBack={goBack} />
  );
}
